module.exports = __webpack_public_path__ + "img/slide2.68233342.jpg";